<script lang="ts" setup>
import { computed } from 'vue';
import {
  HomeIcon,
  ChartPieIcon,
  NewspaperIcon,
  MegaphoneIcon,
  InboxIcon,
  ShoppingBagIcon,
  UserIcon,
  TicketIcon,
  RocketLaunchIcon,
  BuildingStorefrontIcon,
  ChatBubbleOvalLeftEllipsisIcon,
  ArrowPathRoundedSquareIcon
} from '@heroicons/vue/24/outline'
import NavbarList from './NavbarList.vue';
import Logo from "@/assets/img/logo.png"
import { useRoute } from "vue-router";

const route = useRoute();

const storeId = computed(() => {
  return Number(route.params.store_id) ?? 0;
});

const SidebarLinks = [
  {
    title: "Home",
    icon: HomeIcon,
    to: "/",
    children: [

    ]
  },
  {
    // title: storeId.value,
    title: "Orders",
    icon: InboxIcon,
    to: "/orders",
    children: [

    ]
  },
  {
    title: "Products",
    icon: ShoppingBagIcon,
    to: storeId.value ? `/${storeId.value}/products` : "/products",
    children: [
      {
        title: "Inventory",
        to: "/inventory",
        children: [

        ]
      },{
        title: "Categories",
        to: "/categories",
        children: [

        ]
      },
    ]
  },
  {
    title: "Customers",
    icon: UserIcon,
    to: "/customers",
    children: [

    ]
  },
  {
    title: "GameFication",
    icon: RocketLaunchIcon,
    to: "/gamefi",
    children: [
      {
        title: "Bonus program",
        to: "/bonus",
        children: [

        ]
      },{
        title: "Referral program",
        to: "/referral",
        children: [

        ]
      },{
        title: "Wheel of Fortune",
        to: "/fortune",
        children: [

        ]
      },{
        title: "Lootboxes",
        to: "/lootbox",
        children: [

        ]
      },
    ]
  },
  {
    title: "Marketing",
    icon: MegaphoneIcon,
    to: "/marketing",
    children: [
    {
        title: "Statistics",
        to: "/posts",
        children: [

        ]
      },
      {
        title: "Stories",
        to: "/stories",
        children: [

        ]
      },{
        title: "Posts",
        to: "/posts",
        children: [

        ]
      },{
        title: "Automations",
        to: "/posts",
        children: [

        ]
      },
    ]
  },
  // {
  //   title: "Content",
  //   icon: NewspaperIcon,
  //   to: "/content",
  //   children: [
  //   ]
  // },
  {
    title: "Analytics",
    icon: ChartPieIcon,
    to: "/analitycs",
    children: [
      {
        title: "Sales",
        to: "/sales",
        children: [

        ]
      },{
        title: "Shop",
        to: "/shop",
        children: [

        ]
      },
    ]
  },
]

const SalesChannelsLinks = [
  {
    title: "Telegram Mini App",
    icon: BuildingStorefrontIcon,
    // to: "/mini-store",
    to: storeId.value ? `/${storeId.value}/mini-store` : "/mini-store",
    children: [
      {
        title: "Customization",
        to: "/customization",
        children: [

        ]
      },
      {
        title: "Preferences",
        to: "/preferences",
        children: [

        ]
      },
    ]
  },
  {
    title: "Telegram Bot",
    icon: ChatBubbleOvalLeftEllipsisIcon,
    to: "/bot-store",
    children: [

    ]
  },
  {
    title: "Subscriptions for Creators",
    icon: ArrowPathRoundedSquareIcon,
    to: "/sass-creators",
    children: [
      {
        title: "Subscriptions",
        to: "/subscriptions",
        children: [

        ]
      },
    ]
  },
]

</script>

<template lang="pug">
label.drawer-overlay(for='my-drawer-2' aria-label='close sidebar')
aside(class="bg-base-100 min-h-screen w-80 z-20 relative")
  div(class="bg-base-100 sticky top-0 z-20 hidden items-center gap-2 bg-opacity-90 px-4 py-2 backdrop-blur lg:flex ")
    a(href="/" class="flex-0 w-full btn btn-ghost px-2 flex items-center")
      img.w-10(:src="Logo")
      span.font-punk.text-4xl(class="leading-[1.75rem] mt-2")
        span TON
        span.text-primary BAZAAR
  NavbarList.menu(:data="SidebarLinks" :parentPath="''")
  NavbarList.menu(:data="SalesChannelsLinks" :parentPath="''" :title="'Sales channels'")

</template>

<style lang="sass" scoped>

</style>